<template>
  <v-container>
    <v-sheet class="sticky">
      <v-toolbar flat>
        <v-text-field
          v-model="search"
          prepend-icon="mdi-magnify"
          clearable
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-col cols="12" sm="4" class="px-0">
          <v-switch
            v-model="activePlansFilter"
            x-small
            hide-details
            class="mx-1 mt-1"
          >
            <template v-slot:label>
              <span class="text-body-2">Active Plans only</span></template
            >
          </v-switch>
        </v-col>
        <v-spacer></v-spacer>
        <download-csv-btn
          :headers="_headers"
          :items="deduplicatedAndFilteredList"
          :fileName="'ClientRoster.csv'"
        ></download-csv-btn>
      </v-toolbar>
      <v-toolbar flat>
        <client-roster-display :columns="headers"></client-roster-display>
        <client-roster-filters
          @applyFilters="filteredRoster = $event"
        ></client-roster-filters>
      </v-toolbar>
    </v-sheet>
    <v-data-table
      :headers="_headers"
      :items="deduplicatedAndFilteredList"
      :search="search"
      :loading="loading"
      :items-per-page="10"
      dense
    >
      <template v-for="tab in tabs" v-slot:[`item.${tab.name}`]="{ item }">
        <div
          :key="tab.id"
          class="text-decoration-underline indigo--text"
          style="cursor: pointer"
          @click="togglePanel(tab, item[tab.param])"
        >
          {{ item[tab.name] }}
        </div>
      </template>
      <template v-slot:[`item.formattedFADSubmitted`]="{ item }">
        <v-checkbox
          v-model="item.firstAttendDateSubmittedAt"
          x-small
          :disabled="!Boolean(item.formattedFAD)"
          @change="setFADSubmitted(item, $event)"
        >
          <template v-slot:label>
            <span
              v-if="Boolean(item.firstAttendDateSubmittedAt)"
              class="text-body-2 font-weight-medium"
              >{{ item.formattedFADSubmitted }}</span
            >
            <span v-else></span>
          </template>
        </v-checkbox>
      </template>
    </v-data-table>
    <client-roster-sidebar
      v-if="Boolean(activeComponent)"
      :activeComponent="activeComponent"
      :schoolId="Boolean(selectedSchoolId) ? selectedSchoolId : null"
      :clientId="Boolean(selectedClientId) ? selectedClientId : null"
      :districtAdminId="
        Boolean(selectedDistrictAdminId) ? selectedDistrictAdminId : null
      "
      :providerId="Boolean(selectedProviderId) ? selectedProviderId : null"
      @closePanel="togglePanel()"
    ></client-roster-sidebar>
  </v-container>
</template>

<script>
import ClientRosterFilters from "./client-roster-filters.vue";
import ClientRosterDisplay from "./client-roster-display.vue";
import DownloadCsvBtn from "../Shared/download-csv-btn.vue";
import ClientRosterSidebar from "./client-roster-sidebar.vue";

export default {
  components: {
    ClientRosterFilters,
    ClientRosterDisplay,
    DownloadCsvBtn,
    ClientRosterSidebar,
  },
  data: function () {
    return {
      search: "",
      loading: false,
      filteredRoster: [],
      activeComponent: null,
      selectedSchoolId: null,
      selectedClientId: null,
      selectedDistrictAdminId: null,
      selectedProviderId: null,
    };
  },
  async mounted() {
    this.loading = true;
    await this.$store.dispatch("plansModule/getClientRoster", { programId: 6 });
    this.loading = false;
  },
  computed: {
    headers() {
      return [
        { text: "Client Name", value: "clientName" },
        { text: "DOB", value: "formattedDob" },
        { text: "OSIS", value: "formattedOsis" },
        { text: "District Admin", value: "districtAdminFullName" },
        { text: "District", value: "districtId" },
        { text: "School", value: "schoolName" },
        { text: "Team", value: "teamName" },
        { text: "Service", value: "serviceCode" },
        { text: "Plan Type", value: "planType" },
        { text: "Plan Start Date", value: "formattedServicePlanStartDate" },
        { text: "Plan End Date", value: "formattedServicePlanEndDate" },
        { text: "Mandate", value: "formattedMandate" },
        { text: "Group Size", value: "groupSize" },
        { text: "10/12 Month", value: "tenTwelveMonth" },
        { text: "Language", value: "language" },
        { text: "Location", value: "location" },
        { text: "Semester", value: "semesterCode" },
        { text: "Provider", value: "providerFullName" },
        { text: "Approval Start Date", value: "formattedApprovalStartDate" },
        { text: "Approval End Date", value: "formattedApprovalEndDate" },
        { text: "FAD", value: "formattedFAD" },
        { text: "FAD Submitted", value: "formattedFADSubmitted" },
      ];
    },
    tabs() {
      return [
        {
          id: 1,
          name: "schoolName",
          param: "schoolId",
          component: "SchoolForm",
        },
        {
          id: 2,
          name: "clientName",
          param: "clientId",
          component: "ClientDetails",
        },
        {
          id: 3,
          name: "districtAdminFullName",
          param: "districtAdminId",
          component: "DistrictAdminForm",
        },
        {
          id: 4,
          name: "providerFullName",
          param: "providerId",
          component: "ProviderForm",
        },
      ];
    },
    clientRoster() {
      return this.$store.state.plansModule.clientRoster || [];
    },
    displayColumns() {
      return this.$store.state.plansModule.displayColumns;
    },
    _headers() {
      return this.headers.filter((h) => this.displayColumns.includes(h.value));
    },
    deduplicatedAndFilteredList() {
      const seen = new Set();
      return this.filteredRoster.filter((record) => {
        const key = this.displayColumns.map((f) => record[f]).join("|");
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    },
    activePlansFilter: {
      get() {
        return this.$store.state.plansModule.filters.activePlansFilter;
      },
      set(value) {
        this.$store.dispatch("plansModule/setFilters", {
          filterName: "activePlansFilter",
          filterValue: value,
        });
      },
    },
  },
  methods: {
    togglePanel(item, id) {
      if (Boolean(item)) {
        this.activeComponent = item.component;
        switch (item.param) {
          case "schoolId":
            this.selectedSchoolId = id;
          case "clientId":
            this.selectedClientId = id;
          case "districtAdminId":
            this.selectedDistrictAdminId = id;
          case "providerId":
            this.selectedProviderId = id;
        }
      } else {
        this.activeComponent = null;
      }
    },
    async setFADSubmitted(item, event) {
      this.$store.commit("uxModule/setShowLoader", true);
      await this.$store.dispatch("plansModule/setFADSubmitted", {
        servicePlanId: item.servicePlanId,
        submitted: event,
      });
      this.$store.commit("uxModule/setShowLoader", false);
    },
  },
};
</script>
<style scoped>
.sticky {
  background-color: white;
  position: sticky;
  top: 60px;
  z-index: 1;
}
</style>
